import React from 'react';
type Props = {
    desc?: any;
    pageTitle: string;
    bg: string;
    white?: boolean;
};

const HireProcessAgricultureSoftware: React.FC<Props> = ({ pageTitle, desc, bg, white }) => {
    return (
        <section className={`section-py ${bg}`}>
            <div className={white ? 'text-white container lg:container mx-auto' : 'container lg:container mx-auto'}>
                <div className="row grid md:grid-cols-12 !gap-y-0">
                    <div className="lg:col-span-8 md:col-span-10 lg:col-start-3 md:col-start-2 mb-5 md:mb-[70px] lg:mb-0">
                        <div className="flex flex-col gap-2.5 text-center">
                            <h2 className="mb-0">{pageTitle}</h2>
                            <p className={white ? 'text-white mb-0 fw-600' : 'mb-0 fw-600'}>{desc}</p>
                        </div>
                    </div>
                    <div className="md:col-span-12 lg:col-span-12 xl:col-span-12 text-center about-us-animation agriculture-animation">
                        <div className="process-list process-list-about process-list-aiml process-list-fintech process-list-fintech process-list-agriculture">
                            <div className={white ? 'process-item process-item-white text-center' : 'process-item text-center'}>
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-scope-analysis"></use>
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                            : 'text-textcolor fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                    }
                                >
                                    Scope Analysis Process
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-[#D7DEE5] fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    We begin with a deep dive into your agricultural operations, goals, and user needs. This
                                    includes understanding field realities, compliance requirements, and integration points to
                                    shape a precise development roadmap.
                                </p>
                            </div>
                            <div
                                className={
                                    white
                                        ? 'circle circle-white circle-reverse fitech-circle'
                                        : 'circle circle-reverse fitech-circle'
                                }
                            />
                            <div
                                className={
                                    white
                                        ? 'process-item  process-item-white process-item-reverse text-center'
                                        : 'process-item process-item-reverse text-center'
                                }
                            >
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white process-icon-reverse mx-auto mb-4 grid rounded-full'
                                            : 'process-icon process-icon-reverse mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-sprint-planning"></use>
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                            : 'text-textcolor fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                    }
                                >
                                    Sprint Planning & Execution
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-[#D7DEE5] fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    Our agile development model breaks your project into manageable sprints. We prioritize
                                    high-impact features, ensure regular progress updates, and stay flexible to evolving farm-tech
                                    needs.
                                </p>
                            </div>
                            <div className={white ? 'circle circle-white circle-2' : 'circle circle-2'} />
                            <div className={white ? 'process-item process-item-white text-center' : 'process-item text-center'}>
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-uat"></use>
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                            : 'text-textcolor fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                    }
                                >
                                    UAT & Release
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-[#D7DEE5] fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    Before deployment, your team conducts User Acceptance Testing in real scenarios—validating
                                    that the software meets performance expectations and integrates smoothly into your existing
                                    workflows.
                                </p>
                            </div>
                            <div
                                className={
                                    white ? 'circle circle-white circle-reverse circle-3' : 'circle circle-reverse circle-3'
                                }
                            />
                            <div
                                className={
                                    white
                                        ? 'process-item process-item-white process-item-reverse text-center'
                                        : 'process-item process-item-reverse text-center'
                                }
                            >
                                <div
                                    className={
                                        white
                                            ? 'process-icon process-icon-white mx-auto mb-4 grid rounded-full'
                                            : 'process-icon mx-auto mb-4 grid rounded-full'
                                    }
                                >
                                    <svg>
                                        <use xlinkHref="#ic-aftercare"></use>
                                    </svg>
                                </div>
                                <p
                                    className={
                                        white
                                            ? 'text-white fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                            : 'text-textcolor fw-500 px-2.5 mb-[2px] md:mb-[15px] lg:mb-[15px]'
                                    }
                                >
                                    Aftercare
                                </p>
                                <p
                                    className={
                                        white
                                            ? 'text-[#D7DEE5] fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                            : 'text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag'
                                    }
                                >
                                    Post-launch, we provide proactive monitoring, iterative improvements, and technical support to
                                    keep your software resilient, updated, and ready for the next growing season.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HireProcessAgricultureSoftware;
